import React from "react";

import {
  CameraIcon,
  ClipboardDocumentListIcon,
  ComputerDesktopIcon,
  VideoCameraIcon,
} from "@heroicons/react/24/outline";

const features = [
  {
    name: "Pre-Production & Planning",
    first: "Scriptwriting, storyboarding, and creative development",
    second: "Budgeting, location scouting, and talent sourcing",
    third: "Comprehensive scheduling and logistics",
    href: "#",
    icon: ClipboardDocumentListIcon,
  },
  {
    name: "Production Services",
    first: "Full-scale video and film production",
    second: "On-site crew and equipment coordination",
    third:
      "Experienced directors, cinematographers, and production specialists",
    href: "#",
    icon: VideoCameraIcon,
  },
  {
    name: "Post-Production",
    first: "Professional editing, color correction, and sound design",
    second: "Motion graphics, animations, and visual effects",
    third: "Final output optimized for various media platforms",
    href: "#",
    icon: ComputerDesktopIcon,
  },
  {
    name: "Photography",
    first: "Creative direction and concept development",
    second: "Final output optimized for various media platforms",
    third: "Editing and retouching services",
    href: "#",
    icon: CameraIcon,
  },
];

export function Services() {
  return (
    <div className="bg-gradient-to-b from-slate-100 to-royalBlue py-32 sm:py-18">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-pretty text-4xl font-semibold tracking-tight text-black sm:text-5xl">
            Services we offer
          </h2>
          <p className="mt-6 text-lg/8 text-black">
            From initial concept to the final product.
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            {features.map((feature) => (
              <div
                key={feature.name}
                className="flex flex-col rounded-2xl bg-blue-100 p-8 shadow-sm ring-1 ring-gray-200 hover:shadow-md transition"
              >
                <dt className="text-lg font-semibold text-black">
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-royalBlue text-white">
                    <feature.icon
                      aria-hidden="true"
                      className="h-6 w-6 text-blue"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-4 flex flex-col text-base text-gray-600 space-y-2">
                  <p>• {feature.first}</p>
                  <p>• {feature.second}</p>
                  <p>• {feature.third}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
